// extracted by mini-css-extract-plugin
module.exports = {"wells":"BArVC5vp8PVuPAXtap_1"};